import { Shield, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

const SafeFloridaHomeCTA = () => {
  return (
    <section className="py-10 bg-primary">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-8">
          <div className="flex-shrink-0">
            <div className="w-16 h-16 rounded-full bg-accent/20 flex items-center justify-center">
              <Shield className="w-8 h-8 text-accent" />
            </div>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-primary-foreground mb-2">
              Florida Homeowners: Get Up to $10,000 for Your Roof
            </h2>
            <p className="text-primary-foreground/90 text-base md:text-lg leading-relaxed mb-1">
              The <strong>My Safe Florida Home</strong> program offers eligible homeowners up to $10,000 in grants
              plus free wind mitigation inspections to strengthen your home against hurricanes — including peel &amp; stick underlayment for roof replacements.
            </p>
            <p className="text-sm text-primary-foreground/70">
              O'Brien Contracting is a qualified contractor for approved grant projects.
            </p>
          </div>
          <div className="flex-shrink-0">
            <a
              href="https://mysafeflhome.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button variant="accent" size="lg" className="whitespace-nowrap shadow-lg">
                Apply for the Grant
                <ExternalLink className="ml-2 h-4 w-4" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SafeFloridaHomeCTA;
